import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';

import { hashSelector } from '../../../../../../redux/selectors/selectors';
import { getHttpHeader } from '../../../../../../util/FetchTools';

export function useAlertDetails(selectedAlert, streamName) {
   const hash = useSelector(hashSelector);
   const header = getHttpHeader(hash);

   const { isLoading, isFetching, data: details } = useQuery({
      enabled: !!selectedAlert,
      queryKey: ['alertDetails', selectedAlert?.id],
      queryFn: () =>
         axios
            .get('/v2/alerting/ingest/details', {
               headers: header,
               params: {
                  streams: streamName,
                  from: moment.utc(selectedAlert.first).format(),
                  to: moment.utc(selectedAlert.last).format(),
                  codes: selectedAlert.codes.join(','),
               },
            })
            .then((res) => res.data.data),
      onError: (err) => toast.error(err),
      retry: false,
      refetchOnWindowFocus: false,
   });

   return { details, isFetching: isLoading || isFetching };
}
